import { render, staticRenderFns } from "./BackgroundRenderer.vue?vue&type=template&id=685d5ab8"
import script from "./BackgroundRenderer.vue?vue&type=script&lang=js"
export * from "./BackgroundRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports